import { baseEnvironemnt } from "./environment.base";

export const environment = {
    ...baseEnvironemnt,
    production: true
};
